import { type PeriodicityTypes } from '@hungryroot/rest';
import { segmentAnalytics as analytics } from '@hungryroot/segment';
interface Params {
  productId: number;
  path: string;
  rating: PeriodicityTypes;
}

export function trackPdpOsnReview(params: Params) {
  const { productId, path, rating } = params;

  const pathName = () => {
    if (path.includes('myhungryroot')) return 'myhungryroot';
    else if (path.includes('preferences')) return 'preferences';
    else if (path.includes('edit-delivery')) return 'customization';
    else if (path.includes('delivered')) return 'delivered';
    else return 'myhungryroot';
  };

  analytics.track('Product Reviewed', {
    product_id: productId,
    path: pathName(),
    rating,
    category: 'products',
    location: 'PDP',
    source: 'web',
  });
}
